import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { Stack } from '@nike/nike-design-system-components';
import { mobileOnly } from '../../utils/sharedStyles';

const fadeInFromRight = keyframes`
from {
  opacity: 0;
  transform: translateX(5%);
}
to {
  opacity: 1;
  transform: translateX(0);
}
`;

export const SectionStyled = styled.section`
  display: grid;
  grid-template-columns: repeat(10, minmax(0, 1fr));
  padding-top: var(--podium-cds-size-spacing-xl);
  padding-bottom: var(--podium-cds-size-spacing-xxl);
  .search-results-link-container {
    display: grid;
    column-gap: var(--podium-cds-size-spacing-grid-gutter-l);

    grid-column: 3/9; //lines up with the input of the search bar
    &.is-opened {
      &:not(.has-search-data) {
        opacity: 0;
        animation: ${fadeInFromRight} 0.6s ease-in-out 0.2s forwards;
      }
    }
    &.has-search-data {
      //class added when component has top suggested search data
      grid-template-columns: calc(100% / 6) 1fr;
      grid-column: span 10;
      padding-inline: 48px;
    }
  }

  @media (${mobileOnly}) {
    .search-results-link-container,
    .search-results-link-container.has-search-data {
      grid-column: span 10;
      padding-inline: var(--podium-cds-size-spacing-l);
    }
    .search-results-link-container.has-search-data {
      grid-template-columns: 100%;
      row-gap: var(--podium-cds-size-spacing-xxl);

      > div:first-of-type {
        height: auto;
      }
    }
  }
`;

export const ButtonStyled = styled.button`
  background-color: inherit;
  color: var(--podium-cds-color-text-primary)
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  height: 24px;
  width: 24px;

  &:hover {
    background-color: var(--podium-cds-color-bg-hover);
    border-color: var(--podium-cds-color-bg-hover);
  }
`;

export const StackStyled = styled(Stack)`
  gap: var(--podium-cds-size-spacing-m);
  padding: 12px 0;
`;

export const ListStyled = styled.ul`
  margin-top: 4px;
`;

export const RecentSearchItemStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
